import { Box, Text, useColorModeValue, VStack } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { SettlementVerificationTrigger } from './SettlementVerificationTrigger'

export function SettlementVerificationTab() {
  const { t } = useTranslation()
  const textColor = useColorModeValue('gray.600', 'gray.300')

  return (
    <VStack align="stretch" spacing={4}>
      <Box>
        <Text fontSize="sm" color={textColor}>
          {t('settlements.verification.subtitle')}
        </Text>
      </Box>
      <SettlementVerificationTrigger />
    </VStack>
  )
}
